module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Group Trip Details")]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', [_c('span', {
    staticClass: "label label-success mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-right": "20px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Ongoing\n                        Trip")])]) : (_vm.trip.status == 'completed') ? _c('div', [_c('span', {
    staticClass: "label label-primary mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "156px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Completed\n                        Trip")])]) : (_vm.trip.status == 'halt') ? _c('div', [_c('span', {
    staticClass: "label label-danger mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Halt\n                        Trip")])]) : (_vm.trip.status == 'scheduled') ? _c('div', [_c('span', {
    staticClass: "label label-warning mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "153px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Scheduled\n                        Trip")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "heading_trip"
  }, [_c('h3', [_vm._v(_vm._s(((_vm.trip.tripGroupCode) + ": ")) + _vm._s(_vm.concatenatedData) + " ")])]), _vm._v(" "), _vm._l((_vm.subTripList), function(trips, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border-bottom": "1px solid gray",
        "padding": "20px 0"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('label', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("Trip Code : " + _vm._s(trips.tripCode))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(trips.status == 'ongoing') ? _c('div', [_c('span', {
      staticClass: "label label-success mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "139px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Ongoing\n                                    Trip")])]) : (trips.status == 'completed') ? _c('div', [_c('span', {
      staticClass: "label label-primary mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "156px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Completed\n                                    Trip")])]) : (trips.status == 'halt') ? _c('div', [_c('span', {
      staticClass: "label label-danger mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "139px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Halt\n                                    Trip")])]) : (trips.status == 'scheduled') ? _c('div', [_c('span', {
      staticClass: "label label-warning mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "153px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Scheduled\n                                    Trip")])]) : _vm._e()]), _vm._v(" "), (trips.status == 'ongoing') ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.tripEnd('cancel', trips)
        }
      }
    }, [_vm._v("Cancel Trip")]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.openEditTripDia(trips)
        }
      }
    }, [_vm._v("Update Trip")]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.tripEnd('end', trips)
        }
      }
    }, [_vm._v("End Trip")])]) : _vm._e(), _vm._v(" "), (trips.status == 'completed') ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.openEditTripDia(trips)
        }
      }
    }, [_vm._v("Update Trip")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row trip-detail-tbl"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('th', [_vm._v("From - To :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.startSiteSiteName) + " - " + _vm._s(trips.endSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTripSchedule(trips)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Registration No :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.vehicleIdRegNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Driver Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.driverIdDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device ID :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.deviceIdImei))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "font-size": "17px",
        "color": "#3c8dbc"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("At " + _vm._s(trips.startSiteSiteName) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.originReachedAt,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.startDate,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', {
      staticStyle: {
        "font-size": "17px",
        "color": "#3c8dbc"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("At " + _vm._s(trips.endSiteSiteName) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.destinationReachedAt,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.endDate,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])])])])]), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "2%"
      }
    }, [_c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#gasfilling",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "gasfilling"
      },
      on: {
        "click": function($event) {
          return _vm.toggleGasFlowDetails(trips._id, index)
        }
      }
    }, [_vm._v("Gas Flow Meter Detail")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#odometer",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "odometer"
      },
      on: {
        "click": function($event) {
          return _vm.toggleOdometerDetails(trips._id, index)
        }
      }
    }, [_vm._v("Odometer Details")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#driverDetailsList",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "driverDetailsList"
      },
      on: {
        "click": function($event) {
          return _vm.driverDetails(trips._id, index)
        }
      }
    }, [_vm._v("Driver Details")])])]), _vm._v(" "), (_vm.activeIndex === index) ? _c('div', [_c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "gasfilling"
      }
    }, [_c('div', [_vm._m(0, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Challan Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Capture Type")]), _vm._v(" "), _c('th', [_vm._v("Pressure Gauge Reading")]), _vm._v(" "), (trips.startSiteSiteType != 'LNGT') ? _c('th', [_vm._v("Gas Flow Meter Reading")]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT') ? _c('th', [_vm._v("Weight")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportData), function(gs) {
      return _c('tr', [_c('td', [(gs.reading_1 == 'startTrip' &&
        gs.reading_2 == 'post'
      ) ? _c('div', [_c('a', {
        attrs: {
          "href": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "height": "50px",
          "margin": "2px",
          "width": "50px"
        },
        attrs: {
          "src": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
          "alt": "Not Available"
        }
      })])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(gs.reading_1 == 'startTrip' ?
        trips.startSiteSiteType :
        trips.endSiteSiteType) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(gs.reading_2 == 'pre' ? 'Initial' : 'Final') + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_3 ? gs.reading_3 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_4 ? gs.reading_4 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_5 ? gs.reading_5 : ''))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openUpdateGasFlowDia(gs, trips._id)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('edit details'),
          expression: "'edit details'"
        }],
        staticClass: "fa fa-edit",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v("\n                                                     \n                                                    "), _c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteopenUpdateGasFlowDia(gs)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('delete details'),
          expression: "'delete details'"
        }],
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.reportData && _vm.reportData.length < 4) ? _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.openNewGasFlowDia(trips._id)
        }
      }
    }, [_vm._v("\n                                            Add Gas Flow Meter Details\n                                        ")]) : _vm._e()])]), _vm._v(" "), (trips.startSiteSiteType != 'LNGT' &&
      _vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading &&
      _vm.preStartGas[_vm.preStartGas.length - 1] &&
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading -
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT' &&
      _vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading &&
      _vm.preStartGas[_vm.preStartGas.length - 1] &&
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((_vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading -
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length == 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading - 0
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas.length == 0 &&
      _vm.preStartGas[_vm.postStartGas.length - 1] &&
      _vm.preStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      0 -
      _vm.preStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT' &&
      _vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1]
      .meterReading &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.preEndGas[_vm.preEndGas.length - 1].meterReading - _vm.postEndGas[_vm.postEndGas.length -
      1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType != 'LNGT' &&
      _vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1]
      .meterReading &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.postEndGas[_vm.postEndGas.length - 1].meterReading - _vm.preEndGas[_vm.preEndGas.length -
      1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length == 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s(_vm.postEndGas[
      _vm.postEndGas.length - 1
    ].meterReading.toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length == 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((
      0 -
      _vm.preEndGas[_vm.preEndGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "odometer"
      }
    }, [_c('div', [_vm._m(1, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((_vm.odometer), function(o) {
      return _c('tr', [_c('td', _vm._l((o.image), function(imgs1) {
        return _c('div', [_c('a', {
          attrs: {
            "href": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
            "target": "_blank"
          }
        }, [_c('img', {
          staticStyle: {
            "height": "50px",
            "margin": "2px",
            "width": "50px"
          },
          attrs: {
            "src": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
            "alt": "Not Available"
          }
        })]), _vm._v(" "), _c('br')])
      }), 0), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(o.tripType == 'startTrip' ?
        trips.startSiteSiteType :
        trips.endSiteSiteType) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.meterReading))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.recordedTime))]), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openUpdateTripDia(o)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('edit details'),
          expression: "'edit details'"
        }],
        staticClass: "fa fa-edit",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v("\n                                                     \n                                                    "), _c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteTripDetail(o)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('delete details'),
          expression: "'delete details'"
        }],
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.odometer && _vm.odometer.length < 2) ? _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.openNewTripDia(trips._id)
        }
      }
    }, [_vm._v("\n                                            Add Odometer Details\n                                        ")]) : _vm._e()])]), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.startOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading &&
      _vm.endOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ] &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading &&
      _vm.startOdoMeterReading[
        _vm.startOdoMeterReading.length - 1
      ] &&
      _vm.startOdoMeterReading[
        _vm.startOdoMeterReading.length - 1
      ].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.endOdoMeterReading[_vm.endOdoMeterReading.length - 1].meterReading -
      _vm.startOdoMeterReading[_vm.startOdoMeterReading.length -
        1].meterReading).toFixed(2)) + "\n                                            km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.endOdoMeterReading &&
      _vm.startOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading.length == 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.startOdoMeterReading.length == 0 &&
      _vm.endOdoMeterReading &&
      _vm.endOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ] &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading - 0
    ).toFixed(2)) + "\n                                            km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.endOdoMeterReading &&
      _vm.startOdoMeterReading.length == 0 &&
      _vm.endOdoMeterReading.length == 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (_vm.startRecordedTime &&
      _vm.startRecordedTime.length > 0 &&
      _vm.endRecordedTime &&
      _vm.endRecordedTime.length > 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Travel time from " + _vm._s(trips.startSiteSiteType) + " to\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s(_vm.getTimeDifference(trips.destinationReachedAt, trips.startDate)) + " sec")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "driverDetailsList"
      }
    }, [_c('div', [_vm._m(3, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', _vm._l((_vm.driverDetailsList), function(data) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(data.driverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.checkIn, 'DD-MM-YYYY hh:mm A')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.checkOut, 'DD-MM-YYYY hh:mm A')))])])
    }), 0)])])])]) : _vm._e()]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.trip.status == 'scheduled' || _vm.trip.status == 'halt') ? _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripDetail'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "exceptionTable"
    }
  }, [_c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "tripExceptionTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripEditDialog",
      "height": "220"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editSubTrip.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('tripEditDialog')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.originReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "originReachedAt", $$v)
      },
      expression: "editSubTrip.originReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.startDate),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "startDate", $$v)
      },
      expression: "editSubTrip.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.destinationReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "destinationReachedAt", $$v)
      },
      expression: "editSubTrip.destinationReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.endDate),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "endDate", $$v)
      },
      expression: "editSubTrip.endDate"
    }
  })], 1)]), _vm._v(" "), (_vm.editSubTrip.status == 'ongoing') ? _c('tr', [_c('th', [_vm._v("Change Trip Status")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatus]
    }
  }, [_c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.tripEnd('update', _vm.editSubTrip)
      }
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripDialog",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.edit.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('tripDialog');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.tripType),
      expression: "edit.tripType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edit, "tripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("Destination")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Latitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.latitude),
      expression: "edit.latitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Longitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.longitude),
      expression: "edit.longitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "longitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.meterReading),
      expression: "edit.meterReading"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.meterReading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "meterReading", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.edit.recordedTime),
      callback: function($$v) {
        _vm.$set(_vm.edit, "recordedTime", $$v)
      },
      expression: "edit.recordedTime"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.edit.title == 'Create trip') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Image:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "image"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.edit.title == 'Create trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createTrip()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.edit.title == 'Update trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateTrip()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editGasFlow.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('gasFlowDia');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_1),
      expression: "editGasFlow.reading_1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("DBS")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Capture Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_2),
      expression: "editGasFlow.reading_2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Initial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Final")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Pressure Gauge Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_3),
      expression: "editGasFlow.reading_3"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Gas Flow Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_4),
      expression: "editGasFlow.reading_4"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_4", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editGasFlow.reading_5),
      callback: function($$v) {
        _vm.$set(_vm.editGasFlow, "reading_5", $$v)
      },
      expression: "editGasFlow.reading_5"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.editGasFlow.title == 'Add Gas Flow Details' && _vm.editGasFlow.reading_1 === 'startTrip' && _vm.editGasFlow.reading_2 === 'post') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Challan:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "Upload Challan"
    },
    on: {
      "change": _vm.onFilechanged1
    }
  })]), _vm._v(" "), _c('td', [_c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "Upload Challan"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.editGasFlow.title == 'Add Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createGasFlowDetails()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.editGasFlow.title == 'Update Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateGasFlowDetails()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Gas Flow Meter Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Driver Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('th', [_vm._v("Check In")]), _vm._v(" "), _c('th', [_vm._v("Check Out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Exception")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f03aa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip-group/Trip-Group-Activity.vue
// module id = 1948
// module chunks = 1